import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { gcApi, webApi } from 'config/axios';
import { handlingSuccessCallback, handlingErrorCallback } from './sagasUtils';

import { isChinaUser } from 'utils/ChinaUtil';

import {
    FETCH_FAVORITE_COURSES,
    FETCH_FAVORITE_COURSES_SUCCESS,
    FETCH_FAVORITE_COURSES_FAIL,
    FETCH_COURSE_DETAIL,
    FETCH_COURSE_DETAIL_SUCCESS,
    FETCH_COURSE_DETAIL_FAIL,
    REQUEST_COURSES,
    REQUEST_GROUP_COURSES,
    REQUEST_SEGMENT_TYPES,
    REQUEST_SURFACE_TYPES,
    REQUEST_WEB_GATEWAY_COURSES,
    REQUEST_WEB_GATEWAY_COURSES_FOR_CHINA,
    FETCH_COURSE_ROUND_TRIP_ROUTE,
    RECEIVE_COURSE_ROUND_TRIP_ROUTE,
    RECEIVE_COURSE_ROUND_TRIP_ROUTE_ERROR,
    FETCH_START_COURSE_ROUND_TRIP_ROUTE,
    CREATE_NEW_COURSE,
    CREATE_NEW_COURSE_SUCCESS,
    CREATE_NEW_COURSE_ERROR,
    UPDATE_COURSE_DATA,
    UPDATE_COURSE_DATA_ERROR,
    UPDATE_COURSE_DATA_SUCCESS,
    UPDATE_COURSE_PRIVACY,
    UPDATE_COURSE_PRIVACY_ERROR,
    UPDATE_COURSE_PRIVACY_SUCCESS,
    FETCH_ELEVATION_DATA_FOR_COURSE_POINTS,
    FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_SUCCESS,
    FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_START,
    FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ERROR,
    FETCH_COURSE_POPULAR_ROUTES,
    FETCH_START_COURSE_POPULAR_ROUTES,
    FETCH_COURSE_POPULAR_ROUTES_SUCCESS,
    FETCH_COURSE_POPULAR_ROUTES_ERROR,
    SET_COURSE_ROUTE_SEGMENT,
    SET_COURSE_ROUTE_SEGMENT_SUCCESS,
    SET_COURSE_ROUTE_SEGMENT_ERROR,
    SET_COURSE_TO_FAVORITE,
    REMOVE_COURSE_FROM_FAVORITE,
    SET_COURSE_TO_FAVORITE_SUCCESS,
    SET_COURSE_TO_FAVORITE_FAIL,
    REMOVE_COURSE_FROM_FAVORITE_FAIL,
    REMOVE_COURSE_FROM_FAVORITE_SUCCESS,
    DELETE_COURSE_START,
    DELETE_COURSE_SUCCESS,
    DELETE_COURSE_ERROR,
    FETCH_COURSE_POINTS,
    FETCH_COURSE_POINTS_START,
    FETCH_COURSE_POINTS_SUCCESS,
    FETCH_COURSE_POINTS_ERROR,
    GET_COURSE_ROUTE_SEGMENT,
    GET_COURSE_ROUTE_SEGMENT_SUCCESS,
    GET_COURSE_ROUTE_SEGMENT_ERROR,
    REQUEST_NEARBY_COURSES,
    DUPLICATE_COURSE,
    FETCH_NEARBY_COURSES_SUCCESS,
    FETCH_NEARBY_COURSES_ERROR,
    FETCH_THIRD_PARTY_CONSUMER_INFO,
    RECEIVE_THIRD_PARTY_CONSUMER_INFO,
    DUPLICATE_COURSE_START,
    DUPLICATE_COURSE_SUCCESS,
    DUPLICATE_COURSE_ERROR,
    FETCH_GEOPOINTS_FOR_COURSES_MINIMAP,
    FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_START,
    FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_SUCCESS,
    FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_ERROR,
    FETCH_COURSE_DETAILS_START,
    FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB,
    FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB_SUCCESS,
    FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB_ERROR,
    REQUEST_COURSE_MAP_MATCH,
    REQUEST_COURSE_MAP_MATCH_DONE,
    CONVERT_ACTIVITY_TO_COURSE,
    FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ON_CHINA_IMPORT_DONE,
    FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ON_CHINA_IMPORT
} from '../actions/ActionTypes';

import {
    receiveCourses,
    receiveGroupCourses,
    setCourseRouteSegment,
    receiveWebGatewayCourses,
    receiveWebGatewayCoursesForChina,
    receiveSegmentType,
    receiveSurfaceType,
    fetchCourseLineSegments,
    setPageStatus
} from '../actions';

import UrlParser from '../backbone/utils/parsers/UrlParser';
import MapViewUtils from '../backbone/views/map/MapViewUtils';
import {
    getCoordinateSystem,
    getCourseLineDataForRouteSegmentRequest,
    removeStartFinishCoursePointsForSave,
    getPointsChangedObject,
    setCourseLines,
    setElevationIntoGeoPointsObject
} from '../Courses/Utils';
import MapUtil from 'backbone/views/utils/LeafletMap/utils/Util';
import { deletePowerGuidanceItem } from '../actions/powerGuidanceActions';
import { deletePacePro } from '../reducers/pacePro/paceProBand';
import BaiduConvertService from 'Map/utils/BadiuConvertService';
import LocalizationUtil from 'utils/LocalizationUtil';

import 'utils/course/courseTypeDefs';
import { toQueryString } from 'utils/UrlUtil';

// worker
export function* fetchFavoriteCourses(action) {
    try {
        const response = yield call(gcApi.get, `/course-service/course/favorites`);

        yield put({
            type: FETCH_FAVORITE_COURSES_SUCCESS,
            courses: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_FAVORITE_COURSES_FAIL,
            courses: []
        });
    }
}

export function* setCourseToFavorite(action) {
    try {
        let courseId = action.courseId;

        yield call(gcApi.post, `/course-service/course/favorites`, {
            courseId: courseId
        });

        yield put({
            type: SET_COURSE_TO_FAVORITE_SUCCESS,
            courseId: courseId
        });
    } catch (e) {
        yield put({
            type: SET_COURSE_TO_FAVORITE_FAIL
        });
    }
}

export function* removeCourseFromFavorite(action) {
    try {
        let courseId = action.courseId;
        yield call(gcApi.delete, `/course-service/course/favorites/course/${courseId}`);

        yield put({
            type: REMOVE_COURSE_FROM_FAVORITE_SUCCESS,
            courseId: courseId
        });
    } catch (e) {
        yield put({
            type: REMOVE_COURSE_FROM_FAVORITE_FAIL
        });
    }
}

export function* fetchCourseDetail(action) {
    try {
        yield put({
            type: FETCH_COURSE_DETAILS_START
        });
        const params = {};
        if (isChinaUser()) {
            params.targetCoordinateSystem = MapUtil.CoordinateSystem.BD09;
        }
        const response = yield call(gcApi.get, `/course-service/course/${action.courseId}`, { params });

        yield put({
            type: FETCH_COURSE_DETAIL_SUCCESS,
            course: response.data
        });
        if (action.shouldFetchCourseSegments && response.data && response.data.courseId) {
            //because API does not return the points for in the course lines request - same as in the CourseCreateNewView.js
            yield put(fetchCourseLineSegments(response.data.courseId));
        }
    } catch (e) {
        yield put({
            type: FETCH_COURSE_DETAIL_FAIL,
            course: {}
        });
    }
}

export function* fetchCourseSegments(action) {
    try {
        const params = {};
        if (isChinaUser()) {
            params.targetCoordinateSystem = MapUtil.CoordinateSystem.BD09;
        }

        const response = yield call(gcApi.get, `/course-service/course/${action.courseId}/lines`, { params });

        yield put({
            type: GET_COURSE_ROUTE_SEGMENT_SUCCESS,
            courseLines: response.data
        });
    } catch (e) {
        yield put({
            type: GET_COURSE_ROUTE_SEGMENT_ERROR,
            courseLines: []
        });
    }
}

export function* deleteCourse(action) {
    try {
        yield call(gcApi.delete, `/course-service/course/${action.courseId}`);

        yield put({
            type: DELETE_COURSE_SUCCESS,
            courseId: action.courseId
        });
    } catch (e) {
        yield put({
            type: DELETE_COURSE_ERROR,
            course: {}
        });
    }
}

export function* fetchCourses({ displayName, poiLat, poiLon }) {
    try {
        const latSearchParam = poiLat || poiLat === 0 ? `poiLat=${poiLat}` : '';
        const lonSearchParam = poiLon || poiLon === 0 ? `poiLon=${poiLon}` : '';

        const searchParams =
            latSearchParam || lonSearchParam ? `?${[latSearchParam, lonSearchParam].filter(Boolean).join('&')}` : '';

        const response = yield gcApi.get(`/course-service/course/owner/${displayName}${searchParams}`);

        yield put(receiveCourses(response.data));
    } catch (e) {}
}

export function* fetchWebGatewayCourses({ displayName }) {
    try {
        let response = yield gcApi.get(`/web-gateway/course/owner/`);

        yield put(receiveWebGatewayCourses(response.data));
    } catch (e) {}
}

export function* fetchWebGatewayCoursesForChina({ displayName }) {
    try {
        //todo check china handling for endpoint atm handled
        let response = yield gcApi.get(
            '/course-service/course/to/' + MapUtil.CoordinateSystem.BD09 + '/CN/owner/' + displayName
        );
        yield put(receiveWebGatewayCoursesForChina({ coursesForUser: response.data }));
    } catch (e) {}
}

export function* createNewCourse({ payload }) {
    try {
        // start/finish course points are local only, need to remove before sending to API
        const filteredPayload = removeStartFinishCoursePointsForSave(payload);
        let response = yield gcApi.post('/course-service/course', filteredPayload);

        //request to routeSegments is no longer needed since api will accept the lines in the main request -
        // if needed to add - yield put(setCourseRouteSegment(updatedCourseLines)); and use getCourseLineDataForRouteSegmentRequest to get the updatedCourseLines

        yield put({
            type: CREATE_NEW_COURSE_SUCCESS,
            newCourseData: response.data
        });
    } catch (e) {
        yield put({
            type: CREATE_NEW_COURSE_ERROR
        });
    }
}

export function* updateCourseData({ payload, powerGuideIds = [], paceProIds = [], inlineMode }) {
    try {
        // start/finish course points are local only, need to remove before sending to API
        const filteredPayload = removeStartFinishCoursePointsForSave(payload);
        //payload should contain courseId
        let response = yield gcApi.put(`/course-service/course/${payload.courseId}`, filteredPayload);

        //request to routeSegments is no longer needed since api will accept the lines in the main request -
        // if needed to add - yield put(setCourseRouteSegment(updatedCourseLines)); and use getCourseLineDataForRouteSegmentRequest to get the updatedCourseLines

        yield put({
            type: UPDATE_COURSE_DATA_SUCCESS,
            newCourseData: response.data,
            inlineMode: inlineMode
        });
        // if there is a powerguide or a pacepro and length is not valid, delete it
        if (powerGuideIds.length) {
            const requests = powerGuideIds.map((id) => put(deletePowerGuidanceItem(id)));
            yield all(requests);
        }
        if (paceProIds.length) {
            const requests = paceProIds.map((id) => put(deletePacePro(id)));
            yield all(requests);
        }
        //TODO add climbpro
    } catch (e) {
        yield put({
            type: UPDATE_COURSE_DATA_ERROR
        });
    }
}

export function* updateCoursePrivacy({ payload, courseId }) {
    try {
        // start/finish course points are local only, need to remove before sending to API
        const filteredPayload = removeStartFinishCoursePointsForSave(payload);
        yield gcApi.put(`/course-service/course/${courseId}/privacy`, filteredPayload);

        yield put({
            type: UPDATE_COURSE_PRIVACY_SUCCESS,
            courseId,
            privacyRule: filteredPayload
        });
    } catch (e) {
        yield put({
            type: UPDATE_COURSE_PRIVACY_ERROR
        });
    }
}

export function* setCourseRouteSegmentRequest({ payload }) {
    try {
        //payload should contain an array with course segments with courseId, sortOrder, numberOfPoints, distanceInMeters, bearing
        let response = yield gcApi.post(`/course-service/course/routeSegments`, payload);

        yield put({
            type: SET_COURSE_ROUTE_SEGMENT_SUCCESS,
            courseRouteSegment: response.data
        });
    } catch (e) {
        yield put({
            type: SET_COURSE_ROUTE_SEGMENT_ERROR
        });
    }
}

export function* fetchGroupCourses({ groupId }) {
    try {
        const response = yield gcApi.get(`/course-service/course/group/${groupId}`);

        yield put(receiveGroupCourses(response.data));
    } catch (e) {}
}

export function* fetchSegmentType() {
    try {
        const response = yield gcApi.get(`/segment-service/segment/classifications`);

        yield put(receiveSegmentType(response.data));
    } catch (e) {
        yield put(receiveSegmentType(null));
    }
}

export function* fetchSurfaceType() {
    try {
        const response = yield gcApi.get(`/segment-service/segment/surfaceTypes`);

        yield put(receiveSurfaceType(response.data));
    } catch (e) {
        yield put(receiveSurfaceType(null));
    }
}

export function* fetchCourseRoundTripRoute(action) {
    try {
        yield put({
            type: FETCH_START_COURSE_ROUND_TRIP_ROUTE
        });

        const query = new UrlParser().convertObjectToQueryString(action.params);

        const response = yield gcApi.get(`/course-service/course/roundTripRoutes${query}`);

        yield put({
            type: RECEIVE_COURSE_ROUND_TRIP_ROUTE,
            geoPoints: response.data
        });
    } catch (e) {
        yield put({
            type: RECEIVE_COURSE_ROUND_TRIP_ROUTE_ERROR
        });
    }
}

export function* fetchCoursePopularRoute(action) {
    try {
        yield put({
            type: FETCH_START_COURSE_POPULAR_ROUTES
        });

        const query = new UrlParser().convertObjectToQueryString(action.params);

        const response = yield gcApi.get(`/course-service/course/popularRoutes${query}`);

        yield put({
            type: FETCH_COURSE_POPULAR_ROUTES_SUCCESS,
            addToExistingPoints: true,
            geoPoints: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_COURSE_POPULAR_ROUTES_ERROR
        });
    }
}

export function* fetchElevationDataForCoursePoints(action) {
    try {
        yield put({
            type: FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_START
        });

        let points = action.coursePointsArray;
        let url = '/course-service/course/elevation';

        if (MapViewUtils.userInChina()) {
            url = `/course-service/course/elevation/from/${MapUtil.CoordinateSystem.BD09}/CN`;
        }

        const queryParams = toQueryString({ smoothingEnabled: true });

        const response = yield gcApi.post(`${url}${queryParams}`, points);

        yield put({
            type: FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_SUCCESS,
            geoPointsWithElevation: response.data,
            undo: action.undo
        });

        if (typeof action?.callback === 'function') {
            action.callback();
        }
    } catch (e) {
        yield put({
            type: FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ERROR
        });
    }
}

export function* fetchElevationDataForCoursePointsOnChinaImport(action) {
    try {
        const points = action.coursePointsArray;

        /* china import require using `/elevation/from/{coordinateSystem}/CN` to get proper elevation */

        const url = `/course-service/course/elevation/from/${MapUtil.CoordinateSystem.WGS84}/CN`;

        const queryParams = toQueryString({ smoothingEnabled: true });

        const response = yield gcApi.post(`${url}${queryParams}`, points);

        yield put({
            type: FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ON_CHINA_IMPORT_DONE,
            geoPointsWithElevation: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ERROR
        });
    }
}

export function* fetchAvailableCoursePoints() {
    try {
        yield put({
            type: FETCH_COURSE_POINTS_START
        });

        //this is a static file on web-data
        const response = yield webApi.get(`/web-data/course-points/coursePointsData.json`);

        yield put({
            type: FETCH_COURSE_POINTS_SUCCESS,
            availableCoursePoints: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_COURSE_POINTS_ERROR
        });
    }
}

export function* getDuplicatedCourse(action) {
    try {
        if (action.courseId) {
            yield put({
                type: DUPLICATE_COURSE_START
            });

            const params = {};
            if (isChinaUser()) {
                params.coordinateSystem = MapUtil.CoordinateSystem.BD09;
            }

            const response = yield gcApi.get(`/course-service/course/${action.courseId}/sanitized`, { params });

            yield put({
                type: DUPLICATE_COURSE_SUCCESS,
                duplicatedCourseData: response.data
            });
        }
    } catch (e) {
        yield put(setPageStatus(e.response.status));
        yield put({
            type: DUPLICATE_COURSE_ERROR
        });
    }
}

export function* requestNearbyCourses(action) {
    try {
        let response;
        const urlParser = new UrlParser();
        let queryObj = {
            north: action.bounds.north,
            south: action.bounds.south,
            east: action.bounds.east,
            west: action.bounds.west,
            size: action.size
        };
        if (action.fromCourseIndex && parseInt(action.fromCourseIndex)) {
            queryObj.start = action.fromCourseIndex;
        }
        if (action.sort) {
            queryObj.sort = action.sort;
        }
        if (action.filter && typeof action.filter === 'object') {
            if (action.filter.minDistanceInMeters) {
                queryObj.minDistance = action.filter.minDistanceInMeters * 100; // dont know why api is expecting centimeters
            }
            if (action.filter.maxDistanceInMeters) {
                queryObj.maxDistance = action.filter.maxDistanceInMeters * 100; // dont know why api is expecting centimeters
            }
            if (action.filter.minAscentInMeters) {
                queryObj.minAscent = action.filter.minAscentInMeters * 100; // dont know why api is expecting centimeters
            }
            if (action.filter.maxAscentInMeters) {
                queryObj.maxAscent = action.filter.maxAscentInMeters * 100; // dont know why api is expecting centimeters
            }
            if (action.filter.courseName && action.filter.courseName.length) {
                queryObj.courseNameFilter = action.filter.courseName;
            }
        }

        let queryString = urlParser.convertObjectToQueryString(queryObj);

        if (
            action.filter &&
            typeof action.filter === 'object' &&
            action.filter.courseTypes &&
            action.filter.courseTypes.length
        ) {
            //courseType filter is special - as in it is and key multiple times for each courseType
            const upperCaseCourseTypes = action.filter.courseTypes.map((element) => {
                return element.toUpperCase();
            });

            let courseTypesQueryString = urlParser.convertArrayToQueryString('courseType', upperCaseCourseTypes);

            if (queryString.length) {
                queryString += `&${courseTypesQueryString}`;
            } else {
                queryString += `?${courseTypesQueryString}`;
            }
        }

        if (MapViewUtils.userInChina()) {
            queryString +=
                '&sourceCoordinateSystem=' +
                MapUtil.CoordinateSystem.BD09 +
                '&targetCoordinateSystem=' +
                MapUtil.CoordinateSystem.BD09;
            response = yield call(gcApi.get, `/course-service/course/search${queryString}`);
        } else {
            response = yield call(gcApi.get, `/course-service/course/search${queryString}`);
        }

        yield put({
            type: FETCH_NEARBY_COURSES_SUCCESS,
            fromCourseIndex: action.fromCourseIndex,
            nearbyCourses: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_NEARBY_COURSES_ERROR,
            nearbyCourses: []
        });
    }
}

export function* fetchThirdPartyConsumerInfo(action) {
    try {
        const response = yield gcApi.get(`/consumer-service/consumer/thirdparty/info/${action.consumer}`);

        yield put({
            type: RECEIVE_THIRD_PARTY_CONSUMER_INFO,
            consumer: action.consumer,
            courseId: action.courseId,
            consumerInfo: response.data
        });
    } catch (e) {}
}

export function* fetchGeoPointsForCourses(action) {
    try {
        if (action.coursesList && action.coursesList.length) {
            const urlParser = new UrlParser();
            const queryString = urlParser.convertArrayToQueryString('courseId', action.coursesList);
            const coordinateSystem = getCoordinateSystem(null);
            yield put({
                type: FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_START,
                courseIds: action.coursesList
            });

            const response = yield gcApi.get(
                `/course-service/course/minimaps?coordinateSystem=${coordinateSystem}&${queryString}`
            );

            yield put({
                type: FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_SUCCESS,
                coursesListGeoPoints: response.data.miniMaps
            });
        }
    } catch (e) {
        yield put({
            type: FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_ERROR
        });
    }
}

export function* fetchCoursePopularRouteAndAddFullClimb(action) {
    try {
        yield put({
            type: FETCH_START_COURSE_POPULAR_ROUTES
        });

        const climbGeoPoints = action.climb.map((point) => {
            return [[point.latitude, point.longitude]];
        });

        if (!action.addClimbOnly) {
            const query = new UrlParser().convertObjectToQueryString(action.params);
            const response = yield gcApi.get(`/course-service/course/popularRoutes${query}`);

            yield put({
                type: FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB_SUCCESS,
                addToExistingPoints: true,
                geoPoints: response.data,
                climb: action.climb
            });
        } else {
            yield put({
                type: FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB_SUCCESS,
                addToExistingPoints: true,
                geoPoints: climbGeoPoints,
                climb: action.climb,
                addClimbOnly: action.addClimbOnly
            });
        }
    } catch (e) {
        yield put({
            type: FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB_ERROR
        });
    }
}

export function* requestCourseMapMatchSaga(action) {
    const { courseId } = action;
    try {
        // call translate
        yield call(gcApi.put, `/course-service/course/${courseId}/coordinateSystem/translate`);

        /**
         * we re-fetch course and re-calculate elevation after map match then save it on server again.
         * this is ONLY REQUIRED in China
         * */

        /**
         * fetch course again. courseRes for saving (source geoPoints, unshifted), gcjCourse for elevation calculation.
         * */
        const [courseRes, gcj02CourseRes] = yield all([
            call(gcApi.get, `/course-service/course/${action.courseId}`),
            call(gcApi.get, `/course-service/course/${action.courseId}`, {
                params: { targetCoordinateSystem: MapUtil.CoordinateSystem.GCJ02 }
            })
        ]);

        /**
         *  @type {CourseDTO}
         */
        let courseDto = courseRes.data;

        /**
         *  @type {CourseDTO}
         */
        let gcj02CourseDto = gcj02CourseRes.data;

        let geoPointsWithElevation = null;

        if (gcj02CourseDto && Array.isArray(gcj02CourseDto.geoPoints)) {
            const points = gcj02CourseDto.geoPoints.map((item) => [item.latitude, item.longitude, null]);

            const url = `/course-service/course/elevation/from/${MapUtil.CoordinateSystem.GCJ02}/CN`;

            const elevationResponse = yield gcApi.post(url, points);
            geoPointsWithElevation = elevationResponse.data;
        }

        if (!geoPointsWithElevation) {
            // get course data with BD09, for drawing
            const bd09CourseRes = yield call(gcApi.get, `/course-service/course/${action.courseId}`, {
                params: { targetCoordinateSystem: MapUtil.CoordinateSystem.BD09 }
            });
            yield put({
                type: FETCH_COURSE_DETAIL_SUCCESS,
                course: bd09CourseRes.data
            });
            yield put({
                type: REQUEST_COURSE_MAP_MATCH_DONE
            });
            return;
        }

        // ref: src/reducers/course/courses.js
        // function: onFetchElevationDataForCoursePointsSuccess
        const gcjDataWithElevation = setElevationIntoGeoPointsObject(gcj02CourseDto.geoPoints, geoPointsWithElevation);

        // since data might be shifted. (WGS84 -> GCJ02), we can only set elevation by index
        const dataWithElevation = courseDto.geoPoints.map((item, index) => {
            return {
                ...item,
                elevation: gcjDataWithElevation[index].elevation
            };
        });

        // in read mode, DrawingMethod is always custom, so isRoundTrip is always false
        const isRoundTrip = false;

        const updatedDataFromGeoPoints = getPointsChangedObject(dataWithElevation);

        const courseLines = setCourseLines(isRoundTrip, updatedDataFromGeoPoints.geoPoints, courseDto);

        /**
         * @type {CourseDTO}
         */
        const newCourseDto = {
            ...courseDto,
            ...updatedDataFromGeoPoints,
            courseLines: courseLines
        };

        // elevation re-calculate. saved to server.
        yield gcApi.put(`/course-service/course/${newCourseDto.courseId}`, newCourseDto);

        // get course data with BD09, for drawing
        const response = yield call(gcApi.get, `/course-service/course/${action.courseId}`, {
            params: { targetCoordinateSystem: MapUtil.CoordinateSystem.BD09 }
        });

        // update course detail (redraw)
        yield put({
            type: FETCH_COURSE_DETAIL_SUCCESS,
            course: response.data
        });
        yield put({
            type: REQUEST_COURSE_MAP_MATCH_DONE
        });
    } catch (error) {
        yield put({
            type: REQUEST_COURSE_MAP_MATCH_DONE,
            error: true
        });
    }
}

/**
 *
 * @param {Object} action
 * @param {() => any} action.callback
 * @param {Object} response
 * @param {any} response.data
 * @returns
 */
export function* processBaiduConvertActivityToCourse(action, response) {
    const { callback } = action;
    if (!response.data) {
        yield call(handlingSuccessCallback, callback, response);
        return;
    }

    /**
     * @type {{latitude: number; longitude: number}[]} points to convert
     */
    const inputPoints = [];

    /**
     * @type {GeoPointDTO[]}
     */
    let sourceGeoPoints = [];
    if (response.data.geoPoints) {
        /** make a copy */
        sourceGeoPoints = JSON.parse(JSON.stringify(response.data.geoPoints));
        sourceGeoPoints.forEach((item) => {
            inputPoints.push({
                latitude: item.latitude,
                longitude: item.longitude
            });
        });
    }

    /**
     * @type {CoursePointDTO[]}
     */
    let sourceCoursePoints = [];
    if (response.data.coursePoints) {
        sourceCoursePoints = JSON.parse(JSON.stringify(response.data.coursePoints));
        sourceCoursePoints.forEach((item) => {
            inputPoints.push({
                latitude: item.lat,
                longitude: item.lon
            });
        });
    }

    /**
     * @type {CourseLineDTO[]}
     */
    let sourceCourseLines = [];
    if (response.data.courseLines) {
        sourceCourseLines = JSON.parse(JSON.stringify(response.data.courseLines));
        sourceCourseLines.forEach((courseLine) => {
            const { points } = courseLine;
            if (points) {
                points.forEach((item) => {
                    inputPoints.push({
                        latitude: item.lat,
                        longitude: item.lon
                    });
                });
            }
        });
    }

    if (!inputPoints.length) {
        /** no data to convert. exit */
        yield call(handlingSuccessCallback, callback, response);
        return;
    }

    const outOfChina = inputPoints.some((item) => {
        return LocalizationUtil.isOutOfChina(item.latitude, item.longitude);
    });

    if (outOfChina) {
        /** ignore */
        yield call(handlingSuccessCallback, callback, response);
        return;
    }

    const convertService = new BaiduConvertService();
    /**
     * @type {{ lat: number; lon: number }[]} converted response
     */
    const convertedPoints = yield convertService.fetchGenerator(inputPoints);

    /**
     * @typedef {{
     *  _importFromChina: boolean;
     *  _sourceGeoPoints?: GeoPointDTO[];
     *  _sourceCoursePoints?: CoursePointDTO[];
     *  _sourceCourseLines?: CourseLineDTO[];
     * } & CourseDTO} ConvertedCourseDTO;
     *
     * @type {ConvertedCourseDTO}
     */
    const newResponseData = response.data;
    newResponseData._importFromChina = true;

    if (sourceGeoPoints.length > 0) {
        const newGeoPoints = convertedPoints.slice(0, sourceGeoPoints.length);
        for (let index = 0; index < newGeoPoints.length; index += 1) {
            newResponseData.geoPoints[index].latitude = newGeoPoints[index].lat;
            newResponseData.geoPoints[index].longitude = newGeoPoints[index].lon;
        }
        newResponseData._sourceGeoPoints = sourceGeoPoints;
    }
    if (sourceCoursePoints.length > 0) {
        const newCoursePoints = convertedPoints.slice(
            sourceGeoPoints.length,
            sourceGeoPoints.length + sourceCoursePoints.length
        );
        for (let index = 0; index < newCoursePoints.length; index += 1) {
            newResponseData.coursePoints[index].lat = newCoursePoints[index].lat;
            newResponseData.coursePoints[index].lon = newCoursePoints[index].lon;
        }
        newResponseData._sourceCoursePoints = sourceCoursePoints;
    }
    if (sourceCourseLines.length > 0) {
        const newCourseLinePoints = convertedPoints.slice(sourceGeoPoints.length + sourceCoursePoints.length);
        let totalIndex = 0;
        newResponseData.courseLines.forEach((courseLine) => {
            if (!courseLine.points) {
                return;
            }
            for (let index = 0; index < courseLine.points.length; index += 1) {
                courseLine.points[index].lat = newCourseLinePoints[totalIndex].lat;
                courseLine.points[index].lon = newCourseLinePoints[totalIndex].lon;
                totalIndex += 1;
            }
        });
        newResponseData._sourceCourseLines = sourceCourseLines;
    }

    yield call(handlingSuccessCallback, callback, { data: newResponseData });
}

export function* convertActivityToCourse(action) {
    const { activityId, callback } = action;

    try {
        const response = yield call(gcApi.get, `course-service/course/convert/activity/${activityId}`);
        if (isChinaUser()) {
            yield fork(processBaiduConvertActivityToCourse, action, response);
            return;
        }
        yield call(handlingSuccessCallback, callback, response);
    } catch (error) {
        yield call(handlingErrorCallback, callback);
    }
}

// watcher
export const courseSagas = [
    takeEvery(FETCH_FAVORITE_COURSES, fetchFavoriteCourses),
    takeEvery(SET_COURSE_TO_FAVORITE, setCourseToFavorite),
    takeEvery(REMOVE_COURSE_FROM_FAVORITE, removeCourseFromFavorite),
    takeEvery(FETCH_COURSE_DETAIL, fetchCourseDetail),
    takeEvery(GET_COURSE_ROUTE_SEGMENT, fetchCourseSegments),
    takeEvery(DELETE_COURSE_START, deleteCourse),
    takeEvery(REQUEST_COURSES, fetchCourses),
    takeEvery(REQUEST_WEB_GATEWAY_COURSES, fetchWebGatewayCourses),
    takeEvery(REQUEST_WEB_GATEWAY_COURSES_FOR_CHINA, fetchWebGatewayCoursesForChina),
    takeEvery(REQUEST_GROUP_COURSES, fetchGroupCourses),
    takeEvery(REQUEST_SEGMENT_TYPES, fetchSegmentType),
    takeEvery(REQUEST_SURFACE_TYPES, fetchSurfaceType),
    takeEvery(CREATE_NEW_COURSE, createNewCourse),
    takeEvery(UPDATE_COURSE_DATA, updateCourseData),
    takeEvery(UPDATE_COURSE_PRIVACY, updateCoursePrivacy),
    takeEvery(FETCH_COURSE_ROUND_TRIP_ROUTE, fetchCourseRoundTripRoute),
    takeEvery(FETCH_COURSE_POPULAR_ROUTES, fetchCoursePopularRoute),
    takeEvery(FETCH_ELEVATION_DATA_FOR_COURSE_POINTS, fetchElevationDataForCoursePoints),
    takeEvery(FETCH_COURSE_POINTS, fetchAvailableCoursePoints),
    takeEvery(SET_COURSE_ROUTE_SEGMENT, setCourseRouteSegmentRequest),
    takeEvery(REQUEST_NEARBY_COURSES, requestNearbyCourses),
    takeEvery(FETCH_THIRD_PARTY_CONSUMER_INFO, fetchThirdPartyConsumerInfo),
    takeEvery(FETCH_GEOPOINTS_FOR_COURSES_MINIMAP, fetchGeoPointsForCourses),
    takeEvery(DUPLICATE_COURSE, getDuplicatedCourse),
    takeEvery(FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB, fetchCoursePopularRouteAndAddFullClimb),
    takeLatest(REQUEST_COURSE_MAP_MATCH, requestCourseMapMatchSaga),
    takeLatest(CONVERT_ACTIVITY_TO_COURSE, convertActivityToCourse),
    takeLatest(FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ON_CHINA_IMPORT, fetchElevationDataForCoursePointsOnChinaImport)
];
